import {
  ApiProject,
  ApiProjectSetting,
  ApiProjectSettingKey,
  ApiProjectType,
} from "@incendium/api";
import { projectService } from "Apis";
import { enumToArray } from "Helpers/enumToText";
import { useProjectSharedState } from "Hooks/useSharedState";
import { useCallback } from "react";

const loadSettings = async (selectedProject: ApiProject | null) => {
  if (!selectedProject) {
    return [];
  }

  const res = await projectService.projectsServiceListProjectSettings({
    clientId: selectedProject.clientId!,
    projectId: selectedProject.id!,
  });

  let arr = enumToArray(ApiProjectSettingKey).map((key) => {
    let setting = (res.results || []).find((s) => s.key === key);
    if (setting) {
      return setting;
    } else {
      return {
        key,
      } as ApiProjectSetting;
    }
  }) as ApiProjectSetting[];

  return arr || [];
};
const useProjectSettings = () => {
  const { state, setState, loading, fetched } = useProjectSharedState<
    ApiProjectSetting[]
  >("projectSettings", [], loadSettings);

  const settingByType = useCallback(
    (type: ApiProjectSettingKey) => state.find((s) => s.key === type) || {},
    [state]
  );

  const hasProjectType = useCallback(
    (type: ApiProjectType) => {
      const setting = settingByType(ApiProjectSettingKey.PROJECT_TYPE);
      if (!setting.value) return false;
      const values = (setting.value as string)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      return values.includes(`${type}`);
    },
    [settingByType]
  );

  return {
    settings: state,
    setSettings: setState,
    settingByType,
    hasProjectType,
    loading,
    fetched,
  };
};
export default useProjectSettings;
